
import PriceAreasTable from "@/models/PriceAreasTable";
import { IPriceArea } from "@/typings/timit";
import { Vue, Prop, Component } from "vue-property-decorator";
import Destination from "../models/Destination";
@Component({})
export default class PriceAreaCard extends Vue {
  @Prop({ default: null }) private permissionName!: string | null;
  @Prop({ default: null }) private passengerDestinationId: number | null;
  @Prop({ default: null }) private permissionPriceIncVat!: number | null;
  @Prop({ default: null }) private permissionVatPercent!: number | null;

  get priceArea() {
    if (!this.permissionName) {
      return null;
    }

    const priceAreas = new PriceAreasTable();
    const organizationId = this.destination.organizationId?.toLowerCase() ?? '';
    const priceTable = priceAreas.priceTables.find(p => p.organizationId.toLowerCase() === organizationId);

    if (!priceTable) {
      return null;
    }

    const area = priceTable.priceAreas.find(pt => pt.transportationPermissionName === this.permissionName);

    if (!area) {
      const temporaryPermission: IPriceArea = {
        transportationPermissionName: this.permissionName,
        passengerGroupName: "",
        priceAreas: [0, 0, 0, 0, 0, 0],
      };
      return temporaryPermission;
    }

    return area;
  }

  get destination():Destination | null {
    if (this.passengerDestinationId) {
      const result = (this.$store.state.destination.destinations as Destination[]).find(
        (d) => d.id === this.passengerDestinationId
      );
      return result;
    }
    return null;
  }

  get priceIncVat() {
    if (this.permissionPriceIncVat) {
      return this.permissionPriceIncVat;
    }
    return 0;
  }

  setPrice() {
    if (this.priceArea && this.destination) {
      this.$emit(
        "setPrice",
        this.priceArea.priceAreas[this.destination.priceArea - 1]
      );
    }
  }
}
